// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Txi8","productName":"Table_productName__2E2Lc"};